/** PLAY hub category ids — must match `data-hub-category` in index.html. */
export const HUB_ICON_CATEGORIES = [
  "modes",
  "practice",
  "sandbox",
  "multiplayer",
  "local",
  "challenges",
  "tournaments",
  "marathon",
  "lootdrops",
  "campaign",
  "worldmap",
  "soccer",
] as const;

export type HubIconCategoryId = (typeof HUB_ICON_CATEGORIES)[number];

export const HUB_ICON_CATEGORY_LABELS: Record<HubIconCategoryId, string> = {
  modes: "Modes",
  practice: "Practice",
  sandbox: "Sandbox",
  multiplayer: "Multiplayer",
  local: "Local",
  challenges: "Challenges",
  tournaments: "Tournaments",
  marathon: "Marathon",
  lootdrops: "Lootdrops",
  campaign: "Campaign",
  worldmap: "World Map",
  soccer: "Cursor Soccer",
};

/**
 * Canvas mask dimensions — portrait footprint matching a PLAY hub category card
 * (~3:4, same as .gameHubCard width/height ratio).
 */
export const HUB_ICON_W = 200;
export const HUB_ICON_H = 280;

const HUB_ICON_SET = new Set<string>(HUB_ICON_CATEGORIES);

export function isHubIconCategoryId(id: unknown): id is HubIconCategoryId {
  return typeof id === "string" && HUB_ICON_SET.has(id);
}

export function normalizeHubIconCategoryId(id: unknown): HubIconCategoryId | null {
  return isHubIconCategoryId(id) ? id : null;
}
